// Slug allowlist for posts that have a REAL English body translation.
// Split out of blogBodiesEn.js so LanguageContext / blogHasEn() can check
// membership without pulling the multi-MB body payload into the eager bundle.
// Auto-derived from blogBodiesEn.js keys — keep in sync by running:
//   node scripts/generate-en-slugs.mjs
export const BLOG_EN_SLUGS = new Set([
  "website-laten-maken-kosten-een-eerlijk-overzicht-voor-ondernemers",
  "prachtig-wordpress-webdesign-de-gids-voor-een-website-die-converteert",
  "nieuwe-website-laten-maken-de-checklist-voor-een-succesvolle-start",
  "een-zakelijke-website-laten-maken-die-klanten-oplevert-de-ultieme-checklist",
  "funnel-marketing-de-strategie-voor-stabiele-groei-van-je-bedrijf",
  "betaalbare-website-laten-maken-de-gids-voor-slimme-ondernemers",
  "webshop-laten-maken-in-nederland-de-ultieme-gids-voor-ondernemers",
  "wordpress-webshop-laten-maken-de-complete-gids-voor-ondernemers",
  "woocommerce-specialist-de-partner-die-jouw-webshop-laat-groeien",
  "wordpress-website-de-complete-gids-voor-ondernemers",
  "wordpress-site-laten-maken-het-fundament-voor-jouw-online-groei",
  "een-professionele-website-laten-maken-van-strategie-tot-resultaat",
  "wordpress-website-maken-zelf-doen-of-laten-doen-in-2026",
  "website-op-maat-laten-maken-de-investering-in-jouw-online-succes",
  "wordpress-website-beveiligen-de-essentiele-checklist-voor-ondernemers",
  "wordpress-gehackt-dit-moet-je-nu-direct-doen-stappenplan",
  "hoe-schrijf-je-een-salespage-verkooppagina-landingpage",
  "woocommerce-short-codes-in-transactionele-e-mails-handleiding",
  "10-inzichten-voor-een-succesvolle-membership-lidmaatschap-website",
  "business-opschalen-meer-leads-meer-klanten",
  "een-webshop-starten-waar-moet-je-aan-denken",
  "webdesign-hoe-ervaart-een-bezoeker-jouw-website",
  "voldoet-jouw-marketing-funnel-aan-deze-7-punten",
  "website-laten-maken-de-ultieme-gids-voor-ondernemers",
]);
